import axios from 'axios'
import config from '@/config/config.js'
import store from "@/common/store";


const http = axios.create({
    baseURL: config.hostUrl,
    timeout: 60000,
});

http.interceptors.request.use(function(cfg){
    //1 请求之前可以做一些处理、操作
// eg:请求的loading动画
    //1为所有的请求添加公用部分 =>比如接口前面的配置都是一样的 在这里就可以把相同的抽离出来 统一添加
    // console.log('请求即将开始');
    cfg.baseURL =  config.hostUrl;

    var token = store.state.token;
    if (!token) {
        store.commit('setToken', token);
    }
    // cfg.params["locate"] = 'zh_cn';
    cfg.headers['content-type'] = 'application/x-www-form-urlencoded';
    cfg.headers['Authorization'] = "Bearer "+ token; //accessToken  //storageKey.ACCESS_TOKEN
    return cfg;
},function(err){
    //请求错误之前可以进行处理
    return Promise.reject(err)
});


http.interceptors.response.use(async (response) => { /* 请求之后拦截器 */
    switch (response.status) {
        case 200:
            return response.data;
        case 400:
            // utils.toast('错误的请求');
            return Promise.reject(response.data.message);
        case 401:
            // utils.toast('用户未登录');
            return Promise.reject(response.data.message);
        case 405:
            // utils.toast('当前操作不被允许');
            return Promise.reject(response.data.message);
        case 404:
            // utils.toast("页面不存在");
            return Promise.reject(response.data.message);
        case 429:
            // utils.toast('请求过多，先休息一下吧');
            return Promise.reject(response.data.message);
        case 500:
            // utils.toast('服务器打瞌睡了');
            console.error("服务器打瞌睡了")
            // return Promise.reject(response.data.message);
            break;
        default:
            // utils.toast("请求失败");
            return Promise.reject(response.data.message);
    }
}, (error) => {
    console.error("服务器打瞌睡了 error",error)
     return Promise.reject(error)
});

export {
    http
}



